import { render, staticRenderFns } from "./ButtonFLoating.vue?vue&type=template&id=63715647&scoped=true&"
import script from "./ButtonFLoating.vue?vue&type=script&lang=js&"
export * from "./ButtonFLoating.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFLoating.vue?vue&type=style&index=0&id=63715647&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63715647",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63715647')) {
      api.createRecord('63715647', component.options)
    } else {
      api.reload('63715647', component.options)
    }
    module.hot.accept("./ButtonFLoating.vue?vue&type=template&id=63715647&scoped=true&", function () {
      api.rerender('63715647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/button/ButtonFLoating.vue"
export default component.exports